import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: 100vh;
  overflow-y: auto;
  padding-bottom: 3rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const Content = styled.div`
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 2.2rem;
  color: #0077cc;
  margin-bottom: 1rem;
`;

export const Paragraph = styled.p`
  font-size: 1.15rem;
  color: #444;
  margin-bottom: 2.5rem;
  line-height: 1.6;
`;

export const Form = styled.form`
  text-align: left;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-top: 1.2rem;
  color: #444;
  font-size: 1.1rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.9rem;
  margin-bottom: 1.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
`;

export const CTA = styled.button`
  background-color: #0077cc;
  color: white;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #005fa3;
  }
`;

export const SuccessBox = styled.div`
  background-color: #e6ffed;
  color: #276738;
  padding: 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
  font-weight: 500;
`;
